import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from 'redux/root.reducer';
import { CFCProps, APP_URL } from 'types';
import { SkeletonText, Link, TooltipIcon } from 'carbon-components-react';
import { ChevronRight16 } from '@carbon/icons-react';
import { FaceNeutral } from '@carbon/pictograms-react';
import {
  setForwardEnquiryExternalId,
  setForwardEnquiryIsListView,
  fetchEnquiryById
} from 'redux/enquiries';
import { InformationFilled16 } from '@carbon/icons-react';

const RecentTable: React.FC<Props> = ({
  enquiries,
  isLoading,
  tooltipText
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [enquiryList, setEnquiryList] = useState<any[]>([]);
  const [isHover, setIsHover] = useState(false);

  const clickItem = (item: any) => {
    dispatch(setForwardEnquiryExternalId(item?.jobId?.job));
    dispatch(setForwardEnquiryIsListView(true));
    dispatch(fetchEnquiryById({ enquiryId: item.id, logo: true }));
    history.push(APP_URL.ENQUIRIY_HISTORY);
  };

  useEffect(() => {
    if (enquiries?.items) {
      setEnquiryList(enquiries.items);
    }
  }, [enquiries]);

  return (
    <div
      className="dashboard-component--recent"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className="component-title">
        Recent
        {isHover && tooltipText ? (
          <TooltipIcon
            tooltipText={tooltipText || ''}
            className="dashboard-tooltip-info"
          >
            <InformationFilled16 className="dashboard-tooltip-info-icon" />
          </TooltipIcon>
        ) : null}
      </div>
      <div className="recent-table-container">
        {isLoading ? (
          <>
            <SkeletonText />
            <SkeletonText />
            <SkeletonText />
            <SkeletonText />
            <SkeletonText />
          </>
        ) : (
          <>
            {enquiryList && enquiryList.length > 0 ? (
              enquiryList.map((item: any, index: number) => {
                return (
                  <div
                    key={index}
                    className="recent-table-item"
                    onClick={() => clickItem(item)}
                  >
                    <div
                      className={`recent-table-item-header${
                        item?.userRef === undefined ||
                        item?.userRef === item?.address
                          ? ' no-user-ref'
                          : ''
                      }`}
                    >
                      <div className="recent-table-item-title">
                        Job {item?.jobId?.job}
                      </div>
                      <div className="recent-table-item-subtitle">
                        {item?.userRef || item?.address}
                      </div>
                      <div className="recent-table-item-icon">
                        <ChevronRight16 />
                      </div>
                    </div>
                    {item?.userRef && item?.userRef !== item?.address && (
                      <div className="recent-table-item-content">
                        {item?.address}
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="recent-empty-container">
                <div className="recent-empty-icon">
                  <FaceNeutral />
                </div>
                <div className="recent-empty-desc">
                  <span className="recent-empty-desc--welcome">
                    Hello, welcome …
                  </span>
                  <br />
                  Your most recent enquiries will show up here after you lodge
                  them.{' '}
                  <Link href={APP_URL.LODGE_NEW_ENQUIRY}>
                    Lodge your first enquiry now!
                  </Link>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ enquiresCache }: RootState) => ({
  enquiries: enquiresCache.data.enquiries,
  isLoading: enquiresCache.loading || enquiresCache.loader
});

const connector = connect(mapStateToProps);

type ownProps = {
  tooltipText?: string;
};

type Props = CFCProps<typeof connector> & ownProps;

export default React.memo(connector(RecentTable));
